import { render, staticRenderFns } from "./order-unit-report-table.vue?vue&type=template&id=01b0457c&"
import script from "./order-unit-report-table.vue?vue&type=script&lang=js&"
export * from "./order-unit-report-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports